module.exports = __webpack_public_path__ + "img/emw_3.d2ca004d.png";